module.exports = __webpack_public_path__ + "img/openz.3285f160.png";